// src/redux/slices/navigationSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  previousRoute: null,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setPreviousRoute: (state, action) => {
      state.previousRoute = action.payload;
    },
    clearPreviousRoute: (state) => {
      state.previousRoute = null;
    },
  },
});

export const { setPreviousRoute, clearPreviousRoute } = navigationSlice.actions;

export default navigationSlice.reducer;
